/*
 * @Date: 2023-02-27 09:48:43
 * @LastEditors: Leo
 * @LastEditTime: 2023-05-26 14:03:23
 * @FilePath: \3.0-manger\src\js\section\video-swiper.js
 */

/**
 * 判断元素是否在可视区域
 *
 * @param {HTMLElement} $el - 元素节点
 * @threshold {number} threshold - 距离进入可视范围指定距离时候触发
 */
function isElementVisible($el, threshold = 500) {
  var rect
  if ($el.length) {
    rect = $el[0].getBoundingClientRect();
  } else {
    rect = $el.getBoundingClientRect();
  }
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function throttle(delay, fn) {
  let timer;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
      }, delay);
    }
  }
}

window.youTubeReady = false
window.onYouTubeIframeAPIReady = function () {
  window.youTubeReady = true;
  $('body').trigger('youTubeReady');
  // setTimeout(() => {
  //     $(window).off('scroll.' + 'video-slideshow__youtubeAPI')
  // }, 200);
}

window.loadYouTube = function () {
  if (window.youTubeReady) {
    return;
  }

  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

class VideoSlideshow {
  constructor(el) {
    this.DOM = {
      el
    };
    this.slideshow = null;
    this.config = {
      slideshow: {
        delay: 5000,
        pagination: {
          duration: 5
        }
      }
    };

    this.videos = {}
    this.youtubePlayers = []
    this.youtubeVideoOptions = {
      height: '675',
      width: '1200',
      playerVars: {
        autohide: 0,
        autoplay: 0,
        loop: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: null,
        onStateChange: null
      }
    };

    this.init()
  }
  init() {
    const self = this;
    this.youtubeVideoOptions.events.onReady = this.onVideoPlayerReady.bind(this)
    this.youtubeVideoOptions.events.onStateChange = this.onVideoStateChange.bind(this)

    this.slideshow = new Swiper(this.DOM.el, {
      loop: window.sss === 'page.userGuide' ? false : true,
      initialSlide: 0,
      slidesPerView: "auto",
      spaceBetween: 16,
      observer: false,
      observeParents: true,
      centeredSlides: true,
      followFinger: false,
      speed: 800,
      lazy: true,
      pagination: {
        el: '.slideshow-pagination',
        clickable: true,
        bulletClass: 'slideshow-pagination-item',
        bulletActiveClass: 'active pagination-active',
        clickableClass: 'slideshow-pagination-clickable',
        modifierClass: 'slideshow-pagination-',
        renderBullet: function (index, className) {
          let slideIndex = index,
            number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);

          let paginationItem = '<span class="slideshow-pagination-item">';
          paginationItem = (index <= 8) ? paginationItem +
            '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
            paginationItem;
          paginationItem += '</span>';
          return paginationItem;
        }
      },
      effect: "slide",
      navigation: {
        nextEl: '.slideshow-navigation-button.next',
        prevEl: '.slideshow-navigation-button.prev',
      },
      on: {
        resize: function () {
          setTimeout(() => {
            self.slideshow.update()
          }, 600);
        },
        slideChangeTransitionStart: function () {
          const $nextVideo = this.slides[this.activeIndex].querySelector(".product__video")
          const $videos = $(self.DOM.el).find(".product__video")
          $videos.each(function () {
            var $el = $(this);
            var _id = $(this).attr('id');
            if ($el.data('video-type') === 'youtube') {
              self.stopYoutubeVideo(_id);
            }

            if ($el.data('video-type') === 'mp4') {
              self.stopMp4Video(_id);
            }
          });

          if ($nextVideo) {
            const nextVideoType = $nextVideo.getAttribute("data-video-type")
            const nextVideoId = $nextVideo.getAttribute("id")
            if (nextVideoId && nextVideoType === 'youtube') {
              if (window.youTubeReady) {
                if (self.videos[nextVideoId] && self.videos[nextVideoId].style === 'muted') {
                  self.playVisibleVideo(nextVideoId);
                }
              } else {
                $('body').on('youTubeReady' + '.video-slideshow', function () {
                  if (self.videos[nextVideoId] && self.videos[nextVideoId].style === 'muted') {
                    self.playVisibleVideo(nextVideoId);
                  }
                }.bind(this))
              }
            }

            // Autoplay muted MP4 videos
            if (nextVideoId && self.videos[nextVideoId] && self.videos[nextVideoId].style === 'muted') {
              if (nextVideoType === 'mp4') {
                self.playMp4Video(nextVideoId);
              }
            }
          }
        }
      },
      breakpoints: {
        750: {
          effect: "fade"
        }
      }
    });

    this.DOM.el.querySelectorAll('.swiper-slide-duplicate').forEach((item, index) => {
      const target = item.querySelector(".product__video")
      target.setAttribute("id", `${target.getAttribute("id")}__${index}`)
    })

    this.initEvents();
  }
  initEvents() {
    this.slideshow.on('slideNextTransitionStart', () => {});
    this.slideshow.on('slidePrevTransitionStart', () => {});

    // swiper进入可视区域加载YouTube api
    $(window).on('scroll.' + 'video-slideshow__youtubeAPI', throttle(150, this.swiperVisibilityCheck.bind(this)));

    if (!window.youTubeReady && isElementVisible(this.DOM.el)) {
      window.loadYouTube();

      this.checkIfVideos()
    }
  }

  swiperVisibilityCheck() {
    if (!window.youTubeReady && isElementVisible(this.DOM.el)) {
      window.loadYouTube();
      this.checkIfVideos()
    }

    if (window.youTubeReady && !isElementVisible(this.DOM.el)) { // 移出视口
      const $videos = $(this.DOM.el).find(".product__video")
      const self = this
      $videos.each(function () {
        var $el = $(this);
        var _id = $(this).attr('id');
        if ($el.data('video-type') === 'youtube') {
          self.stopYoutubeVideo(_id);
        }
        if ($el.data('video-type') === 'mp4') {
          self.stopMp4Video(_id);
        }
      });
    }

    if(isElementVisible(this.DOM.el)) {
      const currentSlide = $(this.DOM.el).find(".swiper-slide-active .product__video")
      if(currentSlide.attr("data-video-type") === "mp4") { // 进入视口播放视频
        setTimeout(() => {
          this.playMp4Video(currentSlide.attr("id"));
        }, 100);
      }

      const self = this
      if(currentSlide.attr("data-video-type") === "youtube") {
        setTimeout(() => {
          const playID = currentSlide.attr("id")
          const player = self.youtubePlayers[playID]
          if(player && player.getPlayerState && player.getPlayerState() !== YT.PlayerState.PLAYING) {
            self.playVisibleVideo(playID)
          }
        }, 100);
      }
    }
  }

  destroy(fn) {
    this.slideshow.destroy();
    if(fn && typeof fn === 'function') {
      fn()
      this.checkIfVideos()
    }
  }

  checkIfVideos(container_class = '.video-slideshow', video_class = '.product__video') {
    let _videos = $(container_class).find(video_class);
    if (!_videos.length) {
      return false;
    }

    var videoTypes = [];

    _videos.each(function () {
      var type = $(this).data('video-type');
      if (videoTypes.indexOf(type) < 0) {
        videoTypes.push(type);
      }
    });

    // Load YouTube API if not already loaded
    if (videoTypes.indexOf('youtube') > -1) {
      if (!window.youTubeReady) {
        window.loadYouTube();
        $('body').on('youTubeReady' + `${container_class}`, function () {
          this.loadYoutubeVideos(_videos);
        }.bind(this));
      } else {
        this.loadYoutubeVideos(_videos);
      }
    }

    // Add mp4 video players
    if (videoTypes.indexOf('mp4') > -1) {
      this.loadMp4Videos(_videos);
    }

    return videoTypes;
  }

  loadYoutubeVideos($videos) {
    const self = this
    $videos.each(function () {
      var $el = $(this);
      if ($el.data('video-type') != 'youtube') {
        return;
      }

      var id = $el.attr('id');
      var videoId = $el.data('youtube-id');

      self.videos[id] = {
        type: 'youtube',
        id: id,
        videoId: videoId,
        style: $el.data('video-style'),
        width: $el.data('video-width'),
        height: $el.data('video-height'),
        attemptedToPlay: false
      };
    });

    // Create player for each YouTube video
    for (var key in this.videos) {
      if (this.videos[key].type === 'youtube') {
        if (this.videos.hasOwnProperty(key)) {
          var args = $.extend({}, this.youtubeVideoOptions, this.videos[key]);

          if (args.style === 'muted') {} else {
            args.playerVars.controls = 1;
            args.playerVars.autoplay = 0;
          }
          this.youtubePlayers[key] = new YT.Player(key, args);
        }
      }
    }
    window.youTubeReady = true;
  }

  onVideoPlayerReady(evt) {
    var $player = $(evt.target.g);
    var playerId = $player.attr('id');
    this.youtubePlayers[playerId] = evt.target; // update stored player
    var player = this.youtubePlayers[playerId];

    if (this.videos[playerId].style === 'muted') {
      this.youtubePlayers[playerId].mute().pauseVideo();
    }

    if ($player.closest(".swiper-slide-active").length === 1) { // 如果只有一屏或者当前slide，则出现在视口自动播放
      if (this.videos[playerId].style === 'muted') {
        this.initCheckVisibility(playerId);
      }
    }
  }

  initCheckVisibility(playerId) {
    // Add out of view pausing
    this.videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {
      id: playerId
    }, throttle(150, this.videoVisibilityCheck.bind(this)));
  }

  videoVisibilityCheck(id) {
    var playerId;
    if (typeof id === 'string') {
      playerId = id;
    } else {
      playerId = id.data.id;
    }
    if (isElementVisible($('#' + playerId))) {
      if (this.videos[playerId] && this.videos[playerId].style === 'unmuted') {
        return;
      }
      this.playVisibleVideo(playerId);
    } else {
      this.pauseHiddenVideo(playerId);
    }
  }

  /**
   * youtube播放
   *
   * @param {string} id - youtube 节点id
   */
  playVisibleVideo(id) {
    if (this.youtubePlayers[id] && typeof this.youtubePlayers[id].playVideo === 'function') {
      this.youtubePlayers[id].playVideo();
    }
  }

  pauseHiddenVideo(id) {
    if (this.youtubePlayers[id] && typeof this.youtubePlayers[id].pauseVideo === 'function') {
      this.youtubePlayers[id].pauseVideo();
    }
  }

  onVideoStateChange(evt) {
    var $player = $(evt.target.g);
    var playerId = $player.attr('id');
    var player = this.youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer

        if (this.videos[playerId].attemptedToPlay) {
          // setParentAsLoaded($player);
          // setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        // setParentAsLoaded($player);
        break;
      case 3: // buffering
        this.videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  loadMp4Videos($videos) {
    const self = this
    $videos.each(function () {
      var $el = $(this);
      if ($el.data('video-type') != 'mp4') {
        return;
      }

      var id = $el.attr('id');
      var videoId = $el.data('video-id');
      self.videos[id] = {
        type: 'mp4',
        divId: id,
        style: $el.data('video-style')
      };
    });
  }

  playMp4Video(id) {
    var $player = $('#' + id);
    if(!$player.hasClass("isloaded")) {
      this.setVideoSource(id)
      setTimeout(() => {
        $player[0].play();
      }, 20);
    } else {
      $player[0].play();
    }
  }

  setVideoSource(id) {
    var $player = $('#' + id);
    if(!$player.length) {
      return
    }

    const src = $player.data("video-src")
    if(!$player.find('source').length) {
      var source = document.createElement('source');
      source.setAttribute('src', src);
      $player.append(source);
    } else {
      $player.find('source')[0].setAttribute('src', src)
    }
    $player.addClass("isloaded")
    $player[0].load();
  }

  stopMp4Video(id) {
    if (id) {
      $('#' + id)[0].pause();
    } else {
      // loop through all mp4 videos to stop them
      for (var key in videos) {
        if (this.videos[key].type === 'mp4') {
          var player = $('#' + this.videos[key].divId)[0];
          if (typeof player.pause === 'function') {
            player.pause();
          }
        }
      }
    }
  }

  stopYoutubeVideo(id) {
    if (!window.youTubeReady) {
      return;
    }
    if (id && this.youtubePlayers[id]) {
      if (typeof this.youtubePlayers[id].pauseVideo === 'function') {
        this.youtubePlayers[id].pauseVideo();
      }
      $(window).off('scroll.' + id);
    } else {
      try {
        for (key in this.youtubePlayers) {
          if (typeof this.youtubePlayers[key].pauseVideo === 'function') {
            this.youtubePlayers[key].pauseVideo();
            $(window).off('scroll.' + key);
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}

export default VideoSlideshow
